<template>
    <div v-if="isSearching">
        <search-select
            :item="item"
            @update="dispatchUpdate"/>
    </div>
    <div v-else-if="isSelectingList || isRestrictedCustomField">
        <v-select
            :preselect-first="true"
            :options="listOptions"
            :value="values"
            @input="dispatchUpdate"
            :multiple="isMultipleSelectionCustomField"
            :placeholder="staticSelectPlaceholder"
        />
    </div>
    <div v-else-if="isEmpty"><r-input :disabled="true"/></div>
    <div v-else>
        <r-input
            @input="updateInline"
            :auto-resize="true"
            :validate="validate"
            :placeholder="placeholder"
            :value="inlineValues"
            :multiline="true"
            rows="1"/>
    </div>
</template>

<script>
    import BaseEditor from '@/components/query2/components/editors/base-editor';
    import {vSelect, vTagInput} from '@/components/form';
    import SearchSelect from '@/components/query2/components/editors/search-select';
    import QueryLine from '@/components/query2/query-line';
    import pasteToCommaString from '@/common/helpers/paste-to-comma-string';

    export default {
        name: 'text-editor',
        extends: BaseEditor,
        components: {
            vSelect,
            vTagInput,
            SearchSelect,
        },
        computed: {
            isSearching() {
                return this.hasEntities && !this.isSelectingList && !this.isEmpty;
            },
            isRestrictedCustomField() {
                return this.item.hasCustomFieldRestrictions && !this.isEmpty;
            },
            isMultipleSelectionCustomField() {
                return !this.item.isSingleValueCustomField;
            },
            listOptions() {
                if (this.isRestrictedCustomField && !this.isSelectingList) {
                    return this.item.customFieldOptions;
                }
                if (!this.isLoading) {
                    return this.$store.getters['rulesEngine/listOptions'];
                }
                return [];
            },
            staticSelectPlaceholder() {
                return this.isRestrictedCustomField
                    ? `Select ${this.isMultipleSelectionCustomField ? 'values' : 'a value'}`
                    : `Select a values list`;
            },
        },
        watch: {
            async isSelectingList(isActive) {
                if (isActive) {
                    this.isLoading = true;
                    await this.$store.dispatch('rulesEngine/invalidateLists');
                    await this.$store.dispatch('rulesEngine/fetchLists');
                    this.isLoading = false;
                }
            },
            'item.operator': function update(newOperator, oldOperator) {
                const lists = [
                    QueryLine.Operators.inList,
                    QueryLine.Operators.notInlist,
                ];
                // when switching between lists and non-lists reset the values
                // as they are incompatible
                if ((lists.includes(oldOperator)
                    && !lists.includes(newOperator)
                    && newOperator !== QueryLine.Operators.isEmpty)
                    || (lists.includes(newOperator) && !lists.includes(oldOperator))) {
                    this.values = [];
                }
                this.dispatchUpdate(this.values);
            },
        },
        data() {
            return {
                inlineValues: this.item.isSingleValueCustomField
                    ? null
                    : this.decodeData(this.item.coalesceValuesAsArray).join(', '),
                placeholder: 'You can enter several values separate by a comma e.g. value1, value2',
            };
        },
        methods: {
            encodeData(data) {
                this.values = data;
                return Array.isArray(data) ? data : [data];
            },
            decodeData(data) {
                if (this.item.isSingleValueCustomField && data) {
                    const [value = null] = data;
                    return value;
                }
                return data;
            },
            updateInline(data) {
                ({
                    inline: this.inlineValues,
                    values: this.values,
                } = pasteToCommaString(data));

                this.dispatchUpdate(this.values);
            },
        },
    };
</script>
